import type { QueryCache } from '@pinia/colada'

/**
 * Cache utility functions.
 *
 * IMPORTANT: `useQueryCache()` relies on Vue's inject() and can only be called
 * during component setup or inside a composable invoked during setup.
 * These utilities accept a QueryCache parameter so they can be called
 * from any context (stores, composables, actions).
 */

/**
 * Clear entire cache — removes all query entries.
 *
 * Use sparingly — typically only on sign-out or critical state changes.
 *
 * @param queryCache - QueryCache instance obtained from useQueryCache() during setup
 *
 * @example
 * // In a Pinia store setup function:
 * const queryCache = useQueryCache()
 *
 * const logout = async () => {
 *   clearAllCache(queryCache)
 * }
 */
export function clearAllCache(queryCache: QueryCache): void {
  const entries = queryCache.getEntries()
  entries.forEach(entry => queryCache.remove(entry))
}
